import React, { useContext, useEffect } from 'react'
// import { Route } from '../Models/Route';
import { nonRoutes, clientRoutes, adminRoutes } from '../Routes/Routes';
import { useNavigate } from 'react-router-dom';

import jwt from 'jwt-decode'
import { PromiseSesionContext } from '../Machines/ErrorMachine';
import { addMonitor } from '../Api/Monitor';
import { Monitor } from '../Models/Monitor';
import { useLocation } from 'react-router-dom';
import { Route } from '../Models/Route';
import { Client } from '../Models/Client';



interface Props {
    children: React.ReactNode
}

const RolGuard = ({children}:Props) => {
    const {sesion, sendSesion } = useContext(PromiseSesionContext);
    const navigate = useNavigate();


    const [validateAuth, setValidateAuth] = React.useState<boolean>(false);
    const [validateRoutes, setValidateRoutes] = React.useState<boolean>(false);
    const [show, setShow] = React.useState<boolean>(false);
    const [routes, setRoutes] = React.useState<Route[]>(nonRoutes);

    useEffect(() => {
        switch (sesion.context.rol) {
            case 0:
                setRoutes(nonRoutes)
                break;
            case 1:
                setRoutes(clientRoutes)
                break;
            case 2:
                setRoutes(adminRoutes)
                break;
            default:
                setRoutes(nonRoutes)
                break;
        }
        console.log(validateAuth, "autho ")
        if(validateAuth){
            setValidateRoutes(true)
        }

    }, [sesion.context.rol, validateAuth, sesion.value]);

    const validateRoute = ():boolean =>{
        let route =null
        routes.forEach((r:Route)=>{
            if(r.regex){
                if(r.regex.test(window.location.pathname)){
                    route = r
                }
            }
            else{
                if(r.path===window.location.pathname){
                    route = r
                }
            }
        })

        if(route){
            setShow(true)
            return true
        }
        setShow(false)
        return false
    }

    const validateRedirect= ()=>{
        if(!validateRoute()){
            setShow(true)
            if(sesion.context.rol==2){
            navigate("/panel");
            }
            else{
            navigate("/");

            }
        }

    }

    useEffect(() => {
        if(validateAuth && validateRoutes){

            validateRedirect()
        }
      }, [validateAuth, validateRoutes]);

    useEffect(() => {
        try{
            sendSesion("VERIFYYING");
            if (localStorage.getItem("token")) {
              // sendSesion("AUTHORIZED");
              const user:Client = jwt(localStorage.getItem("token") || "")
              sendSesion({type: "AUTHORIZED", data:{user: user, rol: user?.role_id}});
            }
            else{
              sendSesion("UNAUTHORIZED");
            //   navigate("/Login");
            }
            setValidateAuth(true)
        }
        catch(err){
            sendSesion("UNAUTHORIZED");
            navigate("/");
        }
      }, []);

  return (
    <>
        {/* {renderRoutes()} */}
        {
            show ?
            children :
            <></>
        }
    </>
  )
}

export default RolGuard